<script>
  /* Executable code section of the program */
  // Components importation
  import EmptyTable from "../../components/EmptySections/EmptyTable.svelte";
  import CoordinatorModal from "../../components/Modals/ModalCoordinators.svelte";
  import AttendeeCard from "../../components/Cards/AttendeeCard.svelte";
  //Tool importation
  import {
    temporalAttendeeData,
    coordinatorsData,
    isModalCoordinatorsOn,
    userLocalData,
    isProtectedRoute,
    temporalData,
    isModalUpdate,
    isAttendeeCardModalOn,
    isAlertOn,
  } from "../../apis/storage";
  import {
    auth,
    getPaginatedDocuments,
    getSpecificDocuments,
  } from "../../apis/APIS";
  import { onMount } from "svelte";
  import { navigate } from "svelte-routing";
  import { onAuthStateChanged } from "firebase/auth";
  import Loader from "../../components/Loader.svelte";
  import AlertModal from "../../components/Modals/alertModal.svelte";

  //Auxiliary variables
  $: dinamicData = [];
  let isDataLoaded = false;

  //Auxiliary Variables
  let lastDocument = null;
  let reservDocument = [];
  let coordinatorsArray = [];
  let totalCoordinatorssArray = [];
  let isArrayComplete = false;
  let index = 0;
  let totalDocuments = 10;

  // Definition of the window witdh
  const windowWidth = window.innerWidth;
  //Function to go back
  const goBack= () => {
    window.history.back();
  }

  //Function to display card modal
  const displayCardModal = (data) => {
    $isAttendeeCardModalOn = true;
    $temporalAttendeeData = data;
  };

  //Function to display modal
  const displayUpdateModal = (data) => {
    $isModalUpdate = true;
    $temporalData = data;
  };

  //Function to get documents and create pagination
  const nextPageData = async () => {
    if (!isArrayComplete) {
      const { documents, lastDoc } = await getPaginatedDocuments(
        "coordinators",
        "",
        totalDocuments,
        lastDocument
      );
      if (documents.length === 0) {
        isArrayComplete = true;
      }

      if (documents.length > 0) {
        if (
          !totalCoordinatorssArray.some(
            (obj) => JSON.stringify(obj) === JSON.stringify(documents[0])
          ) &&
          !isArrayComplete
        ) {
          totalCoordinatorssArray.push(documents);
          dinamicData = documents;
          lastDocument = lastDoc;
          reservDocument.push(lastDoc);
          index++;
        }
      }
    } else {
      if (index < totalCoordinatorssArray.length - 1) {
        index++;
      }
      dinamicData = totalCoordinatorssArray[index];
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const prevPageData = async () => {
    if (index >= 1) {
      index--;
      if (!isArrayComplete) {
        lastDocument = reservDocument[index];
      }
      dinamicData = totalCoordinatorssArray[index];
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };



  //Logged-in session verification
  //Initial function execution
  onMount(async () => {
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        $isProtectedRoute = true;
        $userLocalData = await getSpecificDocuments("users","email",user.email)
        if (
          $userLocalData[0].userRole === "attendee" ||
          $userLocalData[0].userRole === "coordinator"
        ) {
          navigate("/home");
        }
        
        //fetch documents
        const { documents, lastDoc } = await getPaginatedDocuments(
          "coordinators",
          "",
          totalDocuments,
          lastDocument
        );
        totalCoordinatorssArray.push(documents);
        coordinatorsArray = documents;
        dinamicData = coordinatorsArray;
        lastDocument = lastDoc;
        reservDocument.push(lastDoc);

        // Temporizador del loader
        setTimeout(() => (isDataLoaded = true), 1500);
      } else {
        navigate("/");
      }
    });
  });
  /* End of the section */
</script>

<!-- Section to place the HTML code -->
{#if $isProtectedRoute}
  {#if isDataLoaded}
    <body>
      <div class="backBtnContainer">
        <button class="backBtn" on:click="{goBack}"> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"/>
        </svg> Go Back</button>
      </div>
      <div class="headerContent">
        <h3>Coordinators List</h3>
        <button
          class="btnAddEvent"
          on:click={() => ($isModalCoordinatorsOn = true)}
          >Add Coordinator</button
        >
      </div>
      <div class="listContainer">
        {#if dinamicData.length > 0}
          <table class="table table-striped">
            <thead>
              <tr>
                <th scope="col">Name</th>
                {#if windowWidth > 1100}
                  <th scope="col">Surname</th>
                  <th scope="col">Country</th>
                  <th scope="col">Department</th>
                  <th scope="col">Jobtittle</th>
                  <th scope="col">Email</th>
                  <th scope="col">isLogged</th>
                {:else if windowWidth > 700 && windowWidth <= 1100}
                  <th scope="col">Country</th>
                  <th scope="col">Company</th>
                  <th scope="col">Password</th>
                {/if}
                <th scope="col">Description</th>
                <th scope="col">Edit</th>
              </tr>
            </thead>
            <tbody>
              {#each dinamicData as coordinator, index}
              {#if coordinator.userRole !== "administrator"}
                <tr>
                  {#if windowWidth < 700}
                    <td>{coordinator.name} {coordinator.surname}</td>
                  {/if}
                  {#if windowWidth > 1100}
                    <td>{coordinator.name || "N/A"}</td>
                    <td>{coordinator.surname || "N/A"}</td>
                    <td>{coordinator.country || "N/A"}</td>
                    <td>{coordinator.department || "N/A"}</td>
                    <td>{coordinator.jobtittle || "N/A"}</td>
                    <td>{coordinator.email || "N/A"}</td>
                    <td>{coordinator.password}</td>
                  {:else if windowWidth > 700 && windowWidth <= 1100}
                    <td
                      >{coordinator.name || "N/A"}
                      {coordinator.surname || "N/A"}</td
                    >
                    <td>{coordinator.country || "N/A"}</td>
                    <td>{coordinator.department || "N/A"}</td>
                    <td>{coordinator.password}</td>
                  {/if}
                  <td style="text-align: center;">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      class="bi bi-eye-fill icon"
                      viewBox="0 0 16 16"
                      on:click={() => displayCardModal(coordinator)}
                      on:keypress={() => displayCardModal(coordinator)}
                    >
                      <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
                      <path
                        d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
                      />
                    </svg>
                  </td><td style="text-align: center;">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      class="bi bi-pencil-square icon"
                      viewBox="0 0 16 16"
                      on:click={() => displayUpdateModal(coordinator)}
                      on:keypress={() => displayUpdateModal(coordinator)}
                    >
                      <path
                        d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"
                      />
                      <path
                        fill-rule="evenodd"
                        d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                      />
                    </svg>
                  </td>
                </tr>
              {/if}
              {/each}
            </tbody>
          </table>
        {:else}
          <EmptyTable />
        {/if}
      </div>
      <div class="paginationBtns">
        <button class="actionButton filterBtn" on:click={prevPageData}
          >Previous page</button
        >
        <button class="actionButton filterBtn" on:click={nextPageData}
          >Next page</button
        >
      </div>
    </body>
  {:else}
    <Loader />
  {/if}
  {#if $isModalCoordinatorsOn || $isModalUpdate}
    <CoordinatorModal />
  {/if}
  {#if $isAttendeeCardModalOn}
    <AttendeeCard />
  {/if}
  {#if $isAlertOn}
    <AlertModal/>
  {/if}
{/if}

<!-- End of the section -->
<style>
  /* Section to place the code styles */
  body {
    background-color: #f4f4f4;
    width: 100%;
    min-height: 89vh;
    height: auto;
    padding: 50px 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  /* Back Button styles */
    .backBtnContainer{
    width: 90%;
    display: flex;
    justify-content: flex-start;
  }
  .backBtn{
    background-color: #f4f4f4;
    border: none;
  }
  .backBtn:hover{
    color: #ed2824;
    border-bottom: 1px solid #ed2824;
  }
  .btnAddEvent {
    border-radius: 12px;
    font-size: 14px;
    font-weight: 500;
    padding: 8px 16px;
    background-color: white;
    color: #111;
    border: 1px solid #444;
    transition: all 0.3s ease-in-out;
  }

  .btnAddEvent:hover {
    cursor: pointer;
    box-shadow: #000 0px 0px 5px;
    transform: scale(1.01);
    border-color: #fff;
    background-color: #ed2824;
    color: White;
  }
  .headerContent {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 80%;
    padding: 20px;
  }
  .listContainer {
    background-color: white;
    width: 80%;
    height: auto;
    padding: 30px;
  }
  .icon:hover {
    cursor: pointer;
    color: #ed2824;
  }
  .filterBtn {
    height: 40px;
    width: 100px;
  }
  .actionButton {
    width: 200px;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 500;
    padding: 8px 16px;
    background-color: white;
    color: #111;
    border: 1px solid #444;
    transition: all 0.3s ease-in-out;
    margin: 0 10px;
  }

  .actionButton:hover {
    cursor: pointer;
    box-shadow: #000 0px 0px 5px;
    transform: scale(1.01);
    border-color: #fff;
    background-color: #ed2824;
    color: White;
  }
  .paginationBtns {
    width: 90%;
    height: auto;
    padding: 20px;
    display: flex;
    justify-content: center;
  }

  /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
    .headerContent {
      width: 90%;
    }
    .listContainer {
      background-color: white;
      width: 90%;
      height: auto;
      padding: 30px;
    }
  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {
    .headerContent {
      width: 100%;
      padding: 10px;
      flex-direction: column;
      font-size: 25px;
      align-items: flex-start;
    }
    .filterBtn {
      font-size: 20px;
      padding: 10px;
      height: auto;
      width: 100%;
      margin: 10px 0;
    }
    .listContainer {
      background-color: white;
      width: 100%;
      height: auto;
      padding: 10px;
    }
    .paginationBtns{
      flex-direction: column;

    }
  }



  /* End of the section */
</style>
